import React from 'react'
import Img from "gatsby-image"

const IndexPage = ({data}) => (
  <div>
    <Img sizes={data.file.sizes} />
  </div>
)

export default IndexPage

export const pageQuery = graphql`
	query HeaderImageQuery {
		file: imageSharp(id: { regex: "/monster/" }) {
			sizes(maxWidth: 1240 ) {
				...GatsbyImageSharpSizes
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/index.js